var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_container",style:({
    'background-color': _vm.pageConfig.bgColor,
    backgroundImage: _vm.pageConfig.bgImg ? 'url(' + _vm.pageConfig.bgImg + ')' : '',
  })},[_c('div',{staticClass:"f-1"},_vm._l((_vm.pageComponents),function(item,index){return _c(item.component,{key:index,tag:"component",staticClass:"components_class",attrs:{"datas":item.setStyle}})}),1),_c('myFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }